import {Component, TemplateRef, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {ModalComponent, ModalRef, ModalService} from "@rogers/cdk/modal";
import {CTATypes} from "../../model/common.enum";

@Component({
  selector: 'rch-compatible-devices-modal',
  templateUrl: './compatible-devices-modal.component.html',
  styleUrls: ['./compatible-devices-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompatibleDevicesModalComponent {
  modalRef: ModalRef;
  protected readonly CTATypes = CTATypes;

  constructor(
    private modalService: ModalService,
    private viewContainerRef: ViewContainerRef
  ) {
  }
  openModal(templateRef: TemplateRef<ModalComponent>) {
    this.modalRef = this.modalService.open(templateRef, this.viewContainerRef, null);
  }

  closeModal() {
    this.modalRef.close();
  }

}
